<template>
	<div class="fileDiv" :class="{[`${classPrefix}-transform`]: true, [`${classPrefix}-transform--active`]:selected}" @click="click" @dblclick="dblClick" @mousedown.stop="mousedown">
		<div :class="`${classPrefix}-transform__content`" :style="[computedStyles.element,styles]">
			<slot></slot>
		</div>

		<!--<div class="zjt" v-if="item.name=='X轴管道'||item.name=='Y轴管道'||item.name=='Z轴管道'" :style="computedStyles.controls">
			近端转接头样式
			<img :class="NearEndClassFun" :style="item.rotateDeg === 30||item.rotateDeg===90?common.NearEnd(item.rotateDeg,item.NearNum):common.FarEnd(item.rotateDeg,item.FarNum)" v-show="item.rotateDeg===30||item.rotateDeg===90?item.NearEndMark:item.FarEndMark" :src="item.rotateDeg===30||item.rotateDeg===90?item.NearEndImgUrl:item.FarEndImgUrl" />

			远端转接头样式
			<img :class="FarEndClassFun" :style="item.rotateDeg === 30||item.rotateDeg===90?common.FarEnd(item.rotateDeg,item.FarNum):common.NearEnd(item.rotateDeg,item.NearNum)" v-show="item.rotateDeg===30||item.rotateDeg===90?item.FarEndMark:item.NearEndMark" :src="item.rotateDeg===30||item.rotateDeg===90?item.FarEndImgUrl:item.NearEndImgUrl" />
		</div>-->

		<div v-if="selected" :class="`${classPrefix}-transform__controls`" :style="[computedStyles.controls,stylesoutline]">
			<div :class="`${classPrefix}-transform__rotator`" :style="trTransform" @mousedown.stop="handleRotation"></div>
			<div :class="[`${classPrefix}-transform__scale-point ${classPrefix}-transform__scale-point--tl`]" @mousedown.stop="handleScale('tl',$event)" :style="trTransform"></div>
			<div :class="[`${classPrefix}-transform__scale-point ${classPrefix}-transform__scale-point--ml`]" @mousedown.stop="handleScale('ml',$event)" :style="trTransform"></div>
			<div :class="[`${classPrefix}-transform__scale-point ${classPrefix}-transform__scale-point--tr`]" @mousedown.stop="handleScale('tr',$event)" :style="trTransform"></div>
			<div :class="[`${classPrefix}-transform__scale-point ${classPrefix}-transform__scale-point--tm`]" @mousedown.stop="handleScale('tm',$event)" :style="trTransform"></div>
			<div :class="[`${classPrefix}-transform__scale-point ${classPrefix}-transform__scale-point--bl`]" @mousedown.stop="handleScale('bl',$event)" :style="trTransform"></div>
			<div :class="[`${classPrefix}-transform__scale-point ${classPrefix}-transform__scale-point--bm`]" @mousedown.stop="handleScale('bm',$event)" :style="trTransform"></div>
			<div :class="[`${classPrefix}-transform__scale-point ${classPrefix}-transform__scale-point--br`]" @mousedown.stop="handleScale('br',$event)" :style="trTransform"></div>
			<div :class="[`${classPrefix}-transform__scale-point ${classPrefix}-transform__scale-point--mr`]" @mousedown.stop="handleScale('mr',$event)" :style="trTransform"></div>
      <!-- 6.23添加2d 管道 白色圆球样式-->
			<div :class="[`${classPrefix}-transform__scale-point ${classPrefix}-transform__scale-point--lm`]" @mousedown.stop="handleScale('ml',$event)" :style="trTransform"></div>
			<div :class="[`${classPrefix}-transform__scale-point ${classPrefix}-transform__scale-point--rm`]" @mousedown.stop="handleScale('mr',$event)" :style="trTransform"></div>
		</div>
	</div>
</template>

<script>
	import { styler, scale, translate, rotate } from 'free-transform'

	export default {
		name: 'Transform',
		props: {
			ifConduit: {
				type: Boolean,
				default: false,
			},
			zIndex: {
				type: Number,
				default: 1
			},
			item: {
				type: Object,
				default: () => ({})
			},
			stylesoutline: {
				type: Object,
				default: () => ({})
			},
			spaceMark: {
				type: Boolean,
				default: false,
			},
			classPrefix: {
				type: String,
				default: "tr",
			},
			width: {
				type: Number,
				required: true
			},
			height: {
				type: Number,
				required: true
			},
			x: {
				type: Number,
				required: true
			},
			y: {
				type: Number,
				required: true
			},
			scaleX: {
				type: Number,
				required: true
			},
			scaleY: {
				type: Number,
				required: true
			},
			scaleLimit: {
				type: Number,
				default: 0.1
			},
			angle: {
				type: Number,
				required: true
			},
			disableScale: {
				type: Boolean,
				default: false,
			},
			selected: {
				type: Boolean,
				default: true
			},
			styles: {
				type: Object,
				default: () => ({})
			},
			selectOn: {
				validator: function(value) {
					return ['dblclick', 'mousedown', 'click'].indexOf(value) !== -1
				},
				default: 'mousedown'
			},
			aspectRatio: {
				type: Boolean,
				default: true
			},
			scaleFromCenter: {
				type: Boolean,
				default: true
			},
			enableNativeDrag: {
				default: true,
				type: Boolean
			},
			trTransform: {
				type: Object,
				default: () => ({})
			}
		},
		computed: {
			computedStyles() {
				const {
					element,
					controls
				} = styler({
					x: this.x,
					y: this.y,
					scaleX: this.scaleX,
					scaleY: this.scaleY,
					width: this.width,
					height: this.height,
					angle: this.angle,
					disableScale: this.disableScale
				});
				return {
					payload: {},
					element: {
						...element,
						width: element.width ? `${element.width}px` : null,
						height: element.height ? `${element.height}px` : null,
					},
					controls: {
						...controls,
						width: `${controls.width}px`,
						height: `${controls.height}px`
					}
				}
			},
			NearEndClassFun() {
				if(this.item.rotateDeg == 30) {
					return 'NearEnd30'
				} else if(this.item.rotateDeg == 90) {
					return 'NearEnd90'
				} else {
					return 'FarEnd30'
				}
			},
			FarEndClassFun() {
				if(this.item.rotateDeg == 30) {
					return 'FarEnd30'
				} else if(this.item.rotateDeg == 90) {
					return 'FarEnd90'
				} else {
					return 'NearEnd30'
				}
			},
		},
		methods: {

			/*核心代码 ↓↓↓*/
			handleScale(scaleType, event) {
				event.stopPropagation();
				event.preventDefault();
				const drag = scale(scaleType, {
					startX: event.pageX,
					startY: event.pageY,
					x: this.x,
					y: this.y,
					scaleX: this.scaleX,
					scaleY: this.scaleY,
					width: this.width,
					height: this.height,
					angle: this.angle,
					scaleLimit: this.scaleLimit,
					scaleFromCenter: this.scaleFromCenter && event.altKey,
					enableScaleFromCenter: this.scaleFromCenter,
					aspectRatio: this.aspectRatio && event.shiftKey,
					enableAspectRatio: this.aspectRatio
				}, (payload) => {
					var stopX = (this.x - this.width * this.scaleX) + this.width,
						stopY = (this.y - this.height * this.scaleY) + this.height;
					payload.stopX = stopX;
					payload.stopY = stopY;
					payload.widthHandle = Math.round(this.width * payload.scaleX);
					payload.heightHandle = Math.round(this.height * payload.scaleY);
					payload.Change = 'handleScale';
					this.$emit("update", payload)
				});
				this.onDrag(drag);
			},
			handleTranslation(event) {
				event.stopPropagation();
        let ScaleLevel = this.$store.getters['defaultImgOptions/getScaleLevel'],self = this;
				const drag = translate({
					x: self.x,
					y: self.y,
					startX: event.pageX,
					startY: event.pageY
				}, (payload) => {
					var stopX = ((self.x - self.width * self.scaleX) + self.width) / ScaleLevel,
						stopY = ((self.y - self.height * self.scaleY) + self.height) / ScaleLevel;
					payload.stopX = stopX;
					payload.stopY = stopY;
					payload.Change = 'handleTranslation';
          // console.log(payload)
					self.$emit("update", payload)
				});

				this.onDrag(drag);
			},

			handleRotation(event) {
				event.stopPropagation();
				const drag = rotate({
					startX: event.pageX,
					startY: event.pageY,
					x: this.x,
					y: this.y,
					scaleX: this.scaleX,
					scaleY: this.scaleY,
					width: this.width,
					height: this.height,
					angle: this.angle,
				}, (payload) => {
					payload.Change = 'handleRotation';
					this.$emit("update", payload)
				});

				this.onDrag(drag)
			},

			onDrag(drag) {
				var self = this,Change = sessionStorage.getItem('currentPropsChange');
        let ScaleLevel = this.$store.getters['defaultImgOptions/getScaleLevel'];
				const up = () => {
					document.removeEventListener('mousemove', drag);
					document.removeEventListener('mouseup', up);
					var stopX = ((self.x - self.width * self.scaleX) + self.width) / ScaleLevel,
						stopY = ((self.y - self.height * self.scaleY) + self.height) / ScaleLevel;
					let payload = {
						stopX: stopX,
						stopY: stopY,
						centerPointX: self.x,
						centerPointY: self.y,
						Change: Change
					}
					self.$emit("drag-end", payload);
				};

				document.addEventListener('mousemove', drag);
				document.addEventListener('mouseup', up);
			},
			mousedown(event) {
				if(this.enableNativeDrag) {
					var oEvent = event;
					oEvent.preventDefault && oEvent.preventDefault();
				}
				if(!this.spaceMark) {
					this.$emit("mousedown", event);
					if(this.selectOn === 'mousedown' || this.selected === true) {
						this.$emit('onSelect')
						this.handleTranslation(event)
					}
				}
				return false;
			},
			click(event) {
				this.$emit('click', event)
				if(this.selectOn === 'click') {
					this.$emit('onSelect')
				}
			},

			dblClick(event) {
				this.$emit('dblclick', event)
				if(this.selectOn === 'dblclick') {
					this.$emit('onSelect')
				}
			}

		},
	}
</script>
<style scoped>
	.zjtIndex{
		z-index: 45 !important;
	}
	.ifImgAdd{
		z-index: 46;
	}
	.zjt {
		z-index: 45;
	}

	.NearEnd30 {
		position: absolute;
		/*left: -20px;*/
		/*transform: rotate(-30deg);*/
		top: -10px;
	}

	.FarEnd30 {
		position: absolute;
		/*right: -25px;*/
		/*transform: rotate(-30deg);*/
		top: -8px;
	}

	.NearEnd90 {
		position: absolute;
		left: -9px;
		/*transform: rotate(-30deg);*/
		/*top: -10px;*/
	}

	.FarEnd90 {
		position: absolute;
		right: -11px;
		/*transform: rotate(-30deg);*/
		/*top: -8px;*/
	}
</style>



// WEBPACK FOOTER //
// src/components/MapEditor/canvas/Draggable/FreeTransformCan.vue